import { createUseStyles } from 'react-jss';

export const dropLineBase = {
  'body[drag-active="true"] &': {
    height: '30px',
    zIndex: 10,
    pointerEvents: 'all',
  },
};

const useStyles = createUseStyles(() => ({
  draggable: {
    position: 'relative',

    '& > .dndIcon': {
      color: 'var(--primary-main)',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      left: '4px',
      opacity: 0,
      zIndex: 11,
    },

    '&:hover': {
      '& .dndIcon': {
        opacity: 1,
      },
    },

    '&:not(.disabled)': {
      cursor: 'grab',
    },
  },

  dragOverlay: {
    backgroundColor: 'var(--background-paper)',
    zIndex: 9999,
    pointerEvents: 'none',
    outline: '1px solid var(--primary-main)',
    maxHeight: 'fit-content',
  },

  drag: {
    height: '100%',
    position: 'relative',
    transition: 'all .4s',

    '&.isDragging': {
      opacity: '0.2',
    },

    '&.canDrag:not(:has(.dndIcon))': {
      cursor: 'grab',
    },
  },

  dropLine: {
    ...dropLineBase,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'visible',

    '&:before': {
      content: '""',
      backgroundColor: 'var(--primary-main)',
      border: '1px solid #fff',
      height: '10px',
      width: '10px',
      borderRadius: '50%',
      position: 'absolute',
      left: 0,
    },

    '&:after': {
      content: '""',
      backgroundColor: 'var(--primary-main)',
      borderTop: '1px solid #fff',
      borderBottom: '1px solid #fff',
      height: '2px',
      width: 'calc(100% - 10px)',
      position: 'absolute',
      left: '11px',
    },
  },

  dragLabel: {
    position: 'fixed',
    pointerEvents: 'none',
    left: 0,
    top: 0,
    zIndex: 9999,
    borderRadius: '4px',
    padding: '8px 16px',
    background: 'var(--background-paper)',
    border: '1px solid var(--text-secondary)',
    maxWidth: '400px',
  },
}));

export default useStyles;
